<template>
  <v-card class="ml-1" height="100%">
    <v-card-title>
      <span class="accept-card-title">Informações do aceite</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="3"><span>Usuário: </span></v-col>
          <v-col cols="9"
            ><span>{{ getAcceptHistoryUser() }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col cols="3"><span>Data/Hora aceite: </span></v-col>
          <v-col cols="9"
            ><span>{{ getAcceptHistoryDate() }}</span></v-col
          >
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getAcceptHistoryUser() {
      const { accept_history } = this.campaign.industry
      if (accept_history && accept_history.user && accept_history.user.name && accept_history.user.login) {
        return `${accept_history.user.name} (${accept_history.user.login})`
      } else {
        return '-'
      }
    },

    getAcceptHistoryDate() {
      const { accept_history } = this.campaign.industry
      if (accept_history && accept_history.date) {
        return DateTime.fromISO(accept_history.date).toFormat('dd/MM/yyyy HH:mm')
      } else {
        return '-'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.accept-card-title {
  font-size: 24px;
  font-weight: bold;
  color: $cinza-d20;
}
</style>
